// extracted by mini-css-extract-plugin
export default {"inputForm":"Toasts_inputForm__XzU3b","waiting":"Toasts_waiting__Tm+ac","rot":"Toasts_rot__bO23E","offerInfo":"Toasts_offerInfo__RLXnE","shareBtn":"Toasts_shareBtn__ILK3g"};